import { motion } from "framer-motion";
import { Instagram, Linkedin, Music2, Heart, MessageCircle } from "lucide-react";
import { SOCIAL_PROJECTS } from "@/data/content";

const NET = {
  Instagram: { icon: Instagram, color: "bg-green text-ink" },
  LinkedIn: { icon: Linkedin, color: "bg-forest text-cream" },
  TikTok: { icon: Music2, color: "bg-ink text-mango" },
};

export const SocialProjects = () => {
  return (
    <section
      id="redes"
      data-testid="social-projects-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-32"
    >
      <div className="mb-14 md:mb-20">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-green mb-4">
          Proyectos de redes sociales
        </p>
        <h2 className="font-display font-black text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.9] max-w-3xl">
          Contenido que <span className="text-green">para el scroll</span>.
        </h2>
        <p className="text-ink/60 max-w-md text-base mt-6">
          Una muestra de feeds, campañas y perfiles que hemos hecho crecer.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {SOCIAL_PROJECTS.map((p, i) => {
          const net = NET[p.network] || NET.Instagram;
          const Icon = net.icon;
          return (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              whileHover={{ y: -6 }}
              data-testid={`social-card-${i}`}
              className="group flex flex-col overflow-hidden rounded-3xl bg-white border border-ink/10"
            >
              {/* Card header */}
              <div className="flex items-center gap-3 px-4 py-3">
                <span className="grid place-items-center h-9 w-9 rounded-full bg-gradient-to-tr from-mango to-green text-white font-black text-sm">
                  {p.handle.charAt(0).toUpperCase()}
                </span>
                <div className="leading-tight">
                  <p className="text-sm font-bold text-ink">{p.handle}</p>
                  <p className="text-[11px] text-ink/50">Patrocinado</p>
                </div>
                <span
                  className={`ml-auto inline-flex items-center gap-1.5 rounded-full ${net.color} text-[11px] font-bold px-2.5 py-1`}
                  data-testid={`social-badge-${i}`}
                >
                  <Icon size={13} />
                  {p.network}
                </span>
              </div>

              {/* Image */}
              <div className="relative aspect-square overflow-hidden bg-cream">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105"
                />
              </div>

              {/* Card footer */}
              <div className="px-4 py-4">
                <div className="flex items-center gap-4 mb-3 text-ink/70">
                  <Heart size={20} className="group-hover:text-green group-hover:fill-green transition-colors" />
                  <MessageCircle size={20} />
                </div>
                <p className="font-display font-bold text-lg tracking-tight leading-snug text-ink">
                  {p.title}
                </p>
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
};
